/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export const RECORD = 'RECORD';

export const PRE_RECORD = 'PRE_RECORD';

export const FORMAT_DATE = 'YYYY/MM/DD';

export const CALENDAR_RECORD_MENU = 'CALENDAR_RECORD_MENU';

export const DEFAULT_TITLE_HEIGHT = 18;
export const DEFAULT_FIELD_HEIGHT = 20;

export enum FieldTypeHeight {
  Member = 24,
  Checkbox = 18,
}
